import { Planet } from "../ui/Visualization/Visualization";
import { geologyEarth, geologyJupiter, geologyMars, geologyMercury, geologyNeptune, geologySaturn, geologyUranus, geologyVenus, planetEarth, planetEarthInternal, planetJupiter, planetJupiterInternal, planetMars, planetMarsInternal, planetMercury, planetMercuryInternal, planetNeptune, planetNeptuneInternal, planetSaturn, planetSaturnInternal, planetUranus, planetUranusInternal, planetVenus, planetVenusInternal } from "./planet";


export const planetImages: Record<
  Planet,
  {
    overview: { main: string };
    structure: { main: string };
    geology: { main: string; overlay: string };
  }
> = {
  Mercury: {
    overview: { main: planetMercury },
    structure: { main: planetMercuryInternal },
    geology: { main: planetMercury, overlay: geologyMercury },
  },

  Venus: {
    overview: { main: planetVenus },
    structure: { main: planetVenusInternal },
    geology: { main: planetVenus, overlay: geologyVenus },
  },

  Earth: {
    overview: { main: planetEarth },
    structure: { main: planetEarthInternal },
    geology: { main: planetEarth, overlay: geologyEarth },
  },

  Mars: {
    overview: { main: planetMars },
    structure: { main: planetMarsInternal },
    geology: { main: planetMars, overlay: geologyMars },
  },

  Jupiter: {
    overview: { main: planetJupiter },
    structure: { main: planetJupiterInternal },
    geology: { main: planetJupiter, overlay: geologyJupiter },
  },

  Saturn: {
    overview: { main: planetSaturn },
    structure: { main: planetSaturnInternal },
    geology: { main: planetSaturn, overlay: geologySaturn },
  },

  Uranus: {
    overview: { main: planetUranus },
    structure: { main: planetUranusInternal },
    geology: { main: planetUranus, overlay: geologyUranus },
  },

  Neptune: {
    overview: { main: planetNeptune },
    structure: { main: planetNeptuneInternal },
    geology: { main: planetNeptune, overlay: geologyNeptune },
  },
};

